import { Map, Record } from 'immutable'
import { SUCCESS, FAILED } from 'crom-api-constants'

import { GET_MINIREPORT, GET_MINIREPORT_REQUEST } from './constants'

const GET_MINIREPORT_REQUEST_REQUEST_SUCCESS = `${GET_MINIREPORT_REQUEST}_${SUCCESS}`
const GET_MINIREPORT_REQUEST_REQUEST_FAILED = `${GET_MINIREPORT_REQUEST}_${FAILED}`

const MinireportRecord = Record({
    isLoading: false,
    isLoaded: false,
    isFailed: false,
    data: null,
})

export default (state = Map(), action = {}) => {
    switch (action.type) {
        case GET_MINIREPORT: {
            const id = action?.data?.entId

            if (!id) return state

            const minireport = state
                .get(id, new MinireportRecord())
                .set('isLoading', true)
                .set('isLoaded', false)
                .set('isFailed', false)

            return state.set(id, minireport)
        }
        case GET_MINIREPORT_REQUEST_REQUEST_SUCCESS: {
            const id = action?.payload?.originAction?.data?.entId

            if (!id) return state

            const data = action?.payload?.response?.body ?? {}
            const minireport = state
                .get(id, new MinireportRecord())
                .set('isLoading', false)
                .set('isLoaded', true)
                .set('isFailed', false)
                .set('data', data)

            return state.set(id, minireport)
        }
        case GET_MINIREPORT_REQUEST_REQUEST_FAILED: {
            const id = action?.payload?.originAction?.data?.entId

            if (!id) return state

            return state.set(id, new MinireportRecord()).set('isFailed', true)
        }
        default:
            return state
    }
}
